var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 27.898 4.198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0591f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f89920"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "payment_method_discover_network_card-512",
    transform: "translate(-3.194 -1.927)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M203.408,6.286a2.094,2.094,0,1,1,2.09-2.1A2.094,2.094,0,0,1,203.408,6.286Z",
    transform: "translate(-185.164 -0.162)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M3.2,5.405c0-.575.013-1.15-.007-1.724-.007-.235.072-.294.294-.287.536.033,1.065-.026,1.594.039a1.844,1.844,0,0,1,1.7,1.64A1.923,1.923,0,0,1,5.468,7.267,7.564,7.564,0,0,1,3.332,7.4c-.176.007-.131-.137-.131-.235Zm.719,0c0,.379.007.764-.007,1.143-.007.176.059.222.222.216a5.564,5.564,0,0,0,.81-.059A1.251,1.251,0,0,0,6.062,5.372a1.191,1.191,0,0,0-1.15-1.287c-.255-.033-.523-.02-.777-.039-.176-.013-.222.059-.216.222C3.926,4.647,3.92,5.026,3.92,5.405Z",
    transform: "translate(0 -1.37)",
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    d: "M385.961,5.616c.353.594.686,1.156,1.058,1.77h-.771c-.124,0-.15-.111-.2-.2-.235-.425-.49-.849-.7-1.287-.131-.281-.353-.229-.549-.2s-.078.216-.085.327c-.013.372-.013.738,0,1.11.007.176-.033.248-.229.248-.49.007-.49.013-.49-.47,0-1.078.013-2.156-.007-3.233-.007-.268.085-.327.327-.314a14.876,14.876,0,0,1,1.529.052,1.1,1.1,0,0,1,.96,1.515A1,1,0,0,1,385.961,5.616Zm-1.248-1.084v.392c0,.078,0,.157.111.15.3-.013.607,0,.908-.039a.455.455,0,0,0,.4-.483.455.455,0,0,0-.379-.5,3.441,3.441,0,0,0-.516-.046C384.714,4,384.714,4,384.714,4.532Z",
    transform: "translate(-355.927 -1.353)",
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    d: "M331.1,5.39c0-.588.007-1.176,0-1.764,0-.163.039-.229.216-.229.738.007,1.483.013,2.221,0,.307-.007.216.2.222.353s.052.32-.229.307c-.5-.026-1,0-1.5-.013-.17-.007-.216.052-.216.222-.02.764-.026.764.751.764h.686c.379,0,.509.189.4.555-.039.131-.131.085-.209.085-.457.007-.914.013-1.372,0-.189-.007-.261.033-.261.248-.007.849-.013.849.83.849.34,0,.673.013,1.012-.007.274-.013.2.176.189.3s.124.353-.183.346q-1.176-.01-2.351,0c-.176,0-.222-.065-.216-.229C331.1,6.585,331.1,5.991,331.1,5.39Z",
    transform: "translate(-306.479 -1.375)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    d: "M140.876,6.125a1.867,1.867,0,0,1-1.718-1.156,2.131,2.131,0,0,1,.287-2.332A2.028,2.028,0,0,1,141.607,2a1.676,1.676,0,0,1,.444.2c.15.085.379.2.359.34-.02.176-.274.242-.418.366-.078.072-.131.007-.189-.039a1.271,1.271,0,0,0-2.044.732,1.431,1.431,0,0,0,1.293,1.881.885.885,0,0,0,.705-.274c.189-.222.32-.144.5-.007.333.255.34.248.026.516A1.945,1.945,0,0,1,140.876,6.125Z",
    transform: "translate(-126.877)",
    fill: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    d: "M90.736,6.238a1.7,1.7,0,0,1-1.117-.372c-.118-.1-.183-.183-.02-.3a.839.839,0,0,0,.189-.183c.131-.176.229-.176.4-.013a.917.917,0,0,0,1.032.124.477.477,0,0,0,.026-.849,3.406,3.406,0,0,0-.751-.3c-.679-.242-.934-.581-.895-1.189A1.157,1.157,0,0,1,90.632,2.1a1.749,1.749,0,0,1,1.4.222c.15.1.17.183.026.294a.638.638,0,0,0-.111.118c-.144.2-.268.255-.5.078a.811.811,0,0,0-.81-.052.453.453,0,0,0-.294.392.422.422,0,0,0,.242.425,4.29,4.29,0,0,0,.7.268c.751.268,1.039.679.941,1.346a1.307,1.307,0,0,1-1.319,1.039A1.594,1.594,0,0,1,90.736,6.238Z",
    transform: "translate(-80.67 -0.113)",
    fill: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M269.044,6.118c.209-.555.4-1.071.594-1.581.144-.385.281-.771.425-1.156a.691.691,0,0,1,.784-.248c.072.052.033.111.013.17-.49,1.215-.986,2.443-1.476,3.671-.091.222-.268.131-.411.144s-.268.026-.333-.163c-.47-1.221-.954-2.443-1.43-3.658-.02-.052-.059-.131-.013-.15a2.1,2.1,0,0,1,.64-.033c.15-.013.163.111.2.209.32.875.634,1.751.954,2.626A.624.624,0,0,0,269.044,6.118Z",
    transform: "translate(-246.737 -1.084)",
    fill: "#080808"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M68.595,5.343c0-.575.013-1.156-.007-1.731-.013-.274.131-.281.32-.255.163.026.4-.124.4.235-.013,1.176-.013,2.351,0,3.521.007.359-.235.216-.4.242-.183.026-.333.02-.32-.255C68.614,6.518,68.595,5.93,68.595,5.343Z",
    transform: "translate(-61.122 -1.328)",
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M14.2,14.642c0-.379.007-.764-.007-1.143-.007-.17.039-.235.216-.222.261.02.523.007.777.039A1.2,1.2,0,0,1,16.34,14.6a1.251,1.251,0,0,1-1.117,1.333,5.631,5.631,0,0,1-.81.059c-.17.007-.229-.039-.222-.216C14.2,15.406,14.2,15.021,14.2,14.642Z",
    transform: "translate(-10.278 -10.607)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M395,13.58c0-.529,0-.536.523-.523a2.3,2.3,0,0,1,.516.046.5.5,0,0,1-.02.98,7.038,7.038,0,0,1-.908.039c-.111.007-.111-.072-.111-.15Z",
    transform: "translate(-366.213 -10.401)",
    fill: "#f0f0f0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.cbf13d5ffff9e36806b10cce360c7b40.svg";
export { ForwardRef as ReactComponent };